// @ts-ignore
import isKey from 'ember-keyboard/utils/is-key';
import AppNavState from 'volta/services/app-nav-state';

import Controller from '@ember/controller';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

import type BvMetricsService from 'volta/services/bv-metrics';
import type SkuModalService from 'volta/services/sku-modal-service';
import type { TSkuDetailModalTab } from 'volta/services/sku-modal-service';

export default class ProtectedController extends Controller {
  @service skuModalService!: SkuModalService;
  @service bvMetrics!: BvMetricsService;
  @service appNavState!: AppNavState;

  @tracked
  searchModalIsOpened = false;

  constructor() {
    super(...arguments);
    this.setupSearchKey();
  }

  @action
  closeSkuModal() {
    this.bvMetrics.trackAction(this, 'closeSkuModal');
    this.skuModalService.hide();
  }

  @action
  switchSkuModalTab(tab: TSkuDetailModalTab) {
    this.bvMetrics.trackAction(this, 'switchSkuModalTab');
    this.skuModalService.switchTab(tab);
  }

  setupSearchKey() {
    if (document) {
      document.addEventListener('keydown', (e: KeyboardEvent) => this.handleBodyKeyup(e));
    }
  }

  willDestroy() {
    if (document) {
      document.removeEventListener('keydown', (e: KeyboardEvent) => this.handleBodyKeyup(e));
    }
  }

  handleBodyKeyup(e: KeyboardEvent) {
    if (isKey(`keydown:${this.appNavState.searchKeyBinding}`, e)) {
      e.preventDefault();
      this.appNavState.searchResultsAreOpened
        ? this.appNavState.closeSearch()
        : this.appNavState.openSearch();
    }
  }
}
